import { render, staticRenderFns } from "./bp-report-parameters.vue?vue&type=template&id=0b90583c&"
import script from "./bp-report-parameters.vue?vue&type=script&lang=js&"
export * from "./bp-report-parameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports